import { useTranslation } from 'react-i18next';
import Tag from './Tag';

const RenderRefundStatus = ({ status, className }) => {
  const { t } = useTranslation();
  switch (status) {
    case 0:
      return (
        <Tag
          className={`flex py-[4px] px-[8px] items-center gap-[6px] rounded-[1000px] bg-[#F97D16] ${className}`}
          label={
            <span className="text-label-medium font-semibold text-white">
              {t('Pending refund')}
            </span>
          }
        />
      );
    case 1:
      return (
        <Tag
          className={`flex py-[4px] px-[8px] items-center gap-[6px] rounded-[1000px] bg-[#49AC3E] ${className}`}
          label={
            <span className="text-label-medium font-semibold text-white">
              {t('Refunded')}
            </span>
          }
        />
      );

    default:
      return <></>;
  }
};

export default RenderRefundStatus;
